var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    line = _require$doc$builders.line;

var expression = function expression(node, path, print) {
  if (node.expression) {
    if (node.expression.type === 'TupleExpression') {
      return concat([' ', path.call(print, 'expression')]);
    }

    return group(indent(concat([line, path.call(print, 'expression')])));
  }

  return '';
};

var ReturnStatement = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    return concat(['return', expression(node, path, _print), ';']);
  }
};
module.exports = ReturnStatement;